import { render, staticRenderFns } from "./gl-menu-dropdown.vue?vue&type=template&id=223a77f4"
import script from "./gl-menu-dropdown.vue?vue&type=script&lang=js"
export * from "./gl-menu-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports